var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"button is-info is-outlined",on:{"click":_vm.openPreview}},[_vm._v("Preview")])])
}
var staticRenderFns = []

export { render, staticRenderFns }